var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerCore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451,
    height: 106,
    viewBox: "0 0 451 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 451,
    height: 106,
    rx: 5,
    fill: "url(#paint0_linear_691_3642)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_691_3642",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 451,
    height: 106
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 451,
    height: 106,
    rx: 5,
    fill: "url(#paint1_linear_691_3642)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_691_3642)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238.308,
    height: 250.055,
    rx: 9,
    transform: "matrix(0.89256 -0.450929 0.606565 0.795034 176.282 -17.2485)",
    fill: "url(#paint2_linear_691_3642)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.873 72.836C119.827 72.836 120.727 72.6042 121.576 72.1396C122.423 71.6756 123.166 71.0468 123.802 70.2541C124.438 69.4627 124.941 68.588 125.313 67.6313C125.683 66.6759 125.869 65.705 125.869 64.7215C125.869 62.7002 125.14 61.006 123.683 59.6392C122.225 58.2741 120.224 57.5902 117.68 57.5902H103.131V72.836H118.873ZM103.131 47.4263H116.806C117.919 47.4263 118.885 47.2074 119.708 46.7666C120.529 46.3274 121.218 45.7499 121.775 45.0351C122.331 44.3208 122.755 43.5102 123.047 42.6031C123.337 41.6963 123.484 40.8037 123.484 39.9239C123.484 39.0454 123.325 38.1937 123.007 37.3686C122.689 36.5439 122.264 35.8296 121.735 35.2248C121.205 34.6204 120.582 34.1262 119.867 33.7416C119.151 33.3575 118.396 33.1642 117.601 33.1642H103.131V47.4263ZM134.615 39.6867C134.615 40.8933 134.376 42.1805 133.9 43.5508C133.422 44.9214 132.773 46.1828 131.951 47.333C131.129 48.483 130.135 49.4563 128.97 50.2505C127.804 51.0456 126.531 51.471 125.154 51.5249C126.585 51.6347 128.002 52.0574 129.407 52.7926C130.811 53.5276 132.071 54.5231 133.184 55.7767C134.297 57.0309 135.211 58.4751 135.927 60.1096C136.642 61.745 137 63.4893 137 65.3411C137 68.612 136.523 71.3771 135.569 73.6392C134.615 75.9009 133.316 77.7273 131.673 79.1167C130.03 80.5077 128.108 81.5017 125.909 82.101C123.709 82.7002 121.364 83 118.873 83H92V23H117.601C119.932 23 122.133 23.2332 124.2 23.6995C126.267 24.1655 128.068 25.0149 129.606 26.2469C131.143 27.4801 132.361 29.1797 133.263 31.3441C134.164 33.5085 134.615 36.2905 134.615 39.6867Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142 83H153V23H142V83Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 33.164H183.175V83H171.905V33.164H155V23H200V33.164Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189 83L218.94 23H220.061L250 83H237.832L233.269 73.5609C228.604 63.2804 223.939 52.9998 219.274 42.7193C213.239 56.1462 207.203 69.5729 201.168 83H189Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209 74.9692L229 75L218.862 55L209 74.9692Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264.605 83C262.233 83 260.082 82.4917 258.153 81.4751C256.246 80.4365 254.738 79.011 253.63 77.1989C252.543 75.3646 252 73.2983 252 71C252 68.7017 252.543 66.6464 253.63 64.8343C254.738 63 256.246 61.5746 258.153 60.558C260.082 59.5193 262.244 59 264.638 59C266.656 59 268.474 59.3536 270.093 60.0608C271.733 60.768 273.108 61.7845 274.217 63.1105L270.758 66.2928C269.184 64.4807 267.232 63.5746 264.904 63.5746C263.463 63.5746 262.177 63.895 261.046 64.5359C259.916 65.1547 259.029 66.0276 258.386 67.1547C257.765 68.2818 257.454 69.5635 257.454 71C257.454 72.4365 257.765 73.7182 258.386 74.8453C259.029 75.9724 259.916 76.8564 261.046 77.4972C262.177 78.116 263.463 78.4254 264.904 78.4254C267.232 78.4254 269.184 77.5083 270.758 75.674L274.217 78.8564C273.108 80.2044 271.733 81.232 270.093 81.9392C268.452 82.6464 266.623 83 264.605 83Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M288.005 83C285.588 83 283.404 82.4807 281.453 81.442C279.524 80.4033 278.005 78.9779 276.897 77.1657C275.81 75.3315 275.267 73.2762 275.267 71C275.267 68.7238 275.81 66.6796 276.897 64.8674C278.005 63.0331 279.524 61.5967 281.453 60.558C283.404 59.5193 285.588 59 288.005 59C290.422 59 292.595 59.5193 294.524 60.558C296.453 61.5967 297.971 63.0331 299.08 64.8674C300.189 66.6796 300.743 68.7238 300.743 71C300.743 73.2762 300.189 75.3315 299.08 77.1657C297.971 78.9779 296.453 80.4033 294.524 81.442C292.595 82.4807 290.422 83 288.005 83ZM288.005 78.4254C289.38 78.4254 290.621 78.116 291.73 77.4972C292.839 76.8564 293.703 75.9724 294.324 74.8453C294.967 73.7182 295.289 72.4365 295.289 71C295.289 69.5635 294.967 68.2818 294.324 67.1547C293.703 66.0276 292.839 65.1547 291.73 64.5359C290.621 63.895 289.38 63.5746 288.005 63.5746C286.63 63.5746 285.389 63.895 284.28 64.5359C283.171 65.1547 282.296 66.0276 281.653 67.1547C281.032 68.2818 280.721 69.5635 280.721 71C280.721 72.4365 281.032 73.7182 281.653 74.8453C282.296 75.9724 283.171 76.8564 284.28 77.4972C285.389 78.116 286.63 78.4254 288.005 78.4254Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M318.988 82.6022L314.498 76.1381H314.232H309.543V82.6022H304.155V59.3978H314.232C316.294 59.3978 318.079 59.7403 319.587 60.4254C321.117 61.1105 322.292 62.0829 323.112 63.3425C323.932 64.6022 324.343 66.0939 324.343 67.8177C324.343 69.5414 323.921 71.0331 323.079 72.2928C322.258 73.5304 321.083 74.4807 319.553 75.1436L324.775 82.6022H318.988ZM318.888 67.8177C318.888 66.5138 318.467 65.5193 317.624 64.8343C316.782 64.1271 315.551 63.7735 313.933 63.7735H309.543V71.8619H313.933C315.551 71.8619 316.782 71.5083 317.624 70.8011C318.467 70.0939 318.888 69.0994 318.888 67.8177Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M346 78.2928V82.6022H327.974V59.3978H345.568V63.7072H333.329V68.7459H344.138V72.9227H333.329V78.2928H346Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M349.944 52.5486H348V52H352.473V52.5486H350.529V58H349.944V52.5486Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M359 52V58H358.439V53.2L356.266 57.2371H355.989L353.816 53.2257V58H353.255V52H353.737L356.139 56.4486L358.518 52H359Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_691_3642",
    x1: 199.079,
    y1: -0.0000610352,
    x2: 199.079,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2962FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0039CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_691_3642",
    x1: 225.5,
    y1: 0,
    x2: 225.5,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_691_3642",
    x1: 119.154,
    y1: 0,
    x2: 107.917,
    y2: 219.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#517FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2962FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerCore);
export default __webpack_public_path__ + "static/media/BannerCore.7f5c9db66a0d1bfb0b40ef6371332d08.svg";
export { ForwardRef as ReactComponent };